import { render, staticRenderFns } from "./tableDiscount.vue?vue&type=template&id=8bedef24&"
import script from "./tableDiscount.vue?vue&type=script&lang=js&"
export * from "./tableDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports